<template>
  <TemplatesContentfulGuides />
</template>

<script setup>
defineOptions({
  name: 'GuidesPostPage'
})
</script>
